define([
	"./_TextAlign",
	"./PluginFactory"
], function(_TextAlign,PluginFactory) {

	return PluginFactory.declare(_TextAlign, {
		"class": "csi-button-toggle",
		cssValue: "center",
		materialIcon: "format_align_center",
		pluginName: "textCenter",
		title: "CanvasCenterAlignText"
	});
});
